import { render } from "./InternalDashboardLayout.vue?vue&type=template&id=09e08e56&scoped=true"
import script from "./InternalDashboardLayout.vue?vue&type=script&lang=js"
export * from "./InternalDashboardLayout.vue?vue&type=script&lang=js"

import "./InternalDashboardLayout.vue?vue&type=style&index=0&id=09e08e56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09e08e56"]])

export default __exports__